import { render } from "./CardOrders.vue?vue&type=template&id=28f92f22"
import script from "./CardOrders.vue?vue&type=script&lang=js"
export * from "./CardOrders.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__